import { render, staticRenderFns } from "./editCurrencyQuotes.vue?vue&type=template&id=1471d6ef&"
import script from "./editCurrencyQuotes.vue?vue&type=script&lang=js&"
export * from "./editCurrencyQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports